import { useState } from 'react';
import { connect } from 'react-redux';
import { useUnmountPromise } from 'react-use';

import * as actions from '../../insurances/store/actions';
import SelectInput from '../../core/components/forms/SelectInput';
import { useComponentDidMount } from '../../core/hooks';

// interface InsuranceCompanySelectProps {
//   insuranceCompanies?: unknown[]
//   getInsuranceCompanies?(...args: unknown[]): unknown
//   filterKey?: unknown[]
//   // фильтр по определённым ключам, которые нужно показать
//   excludeKey?: unknown[]
// }

const InsuranceCompanySelect = props => {
  const {
    insuranceCompanies,
    getInsuranceCompanies,
    filterKey,
    excludeKey,
    ...rest
  } = props;

  const mounted = useUnmountPromise();
  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    setLoading(true);
    await getInsuranceCompanies();
    setLoading(false);
  };

  let filteredValues = insuranceCompanies;

  if (filterKey) {
    filteredValues = filteredValues.filter(v => filterKey.find(k => v.id === k));
  }
  if (excludeKey) {
    filteredValues = filteredValues.filter(v => !(excludeKey.find(k => v.id === k)));
  }

  useComponentDidMount(() => { mounted(loadData()); });

  return (
    <SelectInput
      { ...rest }
      data={ filteredValues }
      dataTitle='name'
      dataValue='id'
      loading={ loading }
      sort
    />
  );
};

const mapStateToProps = state => ({
  insuranceCompanies: state.insurances.insuranceCompanies,
});

const mapDispatchToProps = {
  getInsuranceCompanies: actions.getInsuranceCompanies,
};

export default connect(mapStateToProps, mapDispatchToProps)(InsuranceCompanySelect);
